<template>

    <div id="idImportadorCotizacionesFormComponent" class="w-100">

        <div v-if="loading" class="w-100">
            <Loading />
        </div>

        <div v-else class="container-fluid">
            <div class="row px-3">
                <div class="col-7">
                    <h4 class="my-2"> Importar </h4>
                </div>
               
            </div>
            <div class="row w-100 mt-2 px-3">

                <div class="col-2">

                    <ui-select
                        label="Cotización"
                        class="w-100"
                        :keys="{ value: 'id', label: 'name' }"
                        placeholder="Seleccione"
                        :options="quotationNavierasList"
                        v-model="quotation"
                    />

                </div>
            

                <div class="col-2">
                    <ui-select
                        label="Tipo Contrato"
                        class="w-100"
                        :keys="{ value: 'id', label: 'name' }"
                        placeholder="Seleccione"
                        :options="tipoContratos"
                        v-model="typeContract"
                        @change="getContracts()"
                    />
                </div>

                
                <div class="col-3">
                    <ui-select
                        label="Contrato"
                        class="w-100"
                        has-search
                        :keys="{ value: 'id', label: 'name' }"
                        placeholder="Seleccione"
                        :options="contractList"
                        v-model="contract"
                    />
                </div>

                <div v-if="showImportFile" class="col-4" >
                    <div class="w-100 d-inline">
                        <input 
                            class="import b-order mt-3" 
                            type="file"
                            ref="fileToImport"
                            id="fileToImport"
                            name="fileToImport" 
                            @change="getFile()"
                            accept=".xlsx"
                        />
                        <span v-if="showDeleteBtn" class="delete zoom mt-3" @click="clearInput()">
                            <i class="fas fa-trash-alt"></i>
                        </span>
                    </div>
                </div>

            
            </div>
            <div class="row w-100 my-3 px-3"  v-if="data.length > 0">
                <div class="col-2">

                    <ui-textbox
                        class="w-100 mt-4"
                        label="N° Cotización"
                        v-model="quotationNumber"
                        disabled
                    />
                </div>
                <div class="col-2">

                    <div class="w-100">
                        <label class="label-date" for="">Desde </label>
                        <date-picker
                            class="w-100 "
                            placeholder="Vigencia Término"
                            type="date"
                            value-type="format"
                            format="DD-MM-YYYY"
                            v-model="from"
                        />
                    </div>
                    
                </div>
                <div class="col-2">

                    <div class="w-100 ">
                        <label class="label-date" for="">Hasta </label>
                        <date-picker
                            class="w-100"
                            placeholder="Vigencia Término"
                            type="date"
                            value-type="format"
                            format="DD-MM-YYYY"
                            v-model="to"
                        />
                    </div>
                    
                </div>
                <div class="col-2">
                    <ui-textbox
                        enforce-maxlength
                        floating-label
                        help="Máximo 256 caracteres"
                        label="Descripción"
                        placeholder="Descripción..."
                        :multi-line="true"
                        :maxlength="256"
                        class="mart-1"
                        v-model="description"
                    />
                </div>
            </div>
            <div class="row w-100 mb-3">
                <div class="col" >

                    <div class="w-100 scroll" v-if="data.length > 0">
                        <div  v-for="(item, index) in data" class="w-100 mt-2 px-3" :key="index">
                            <h6 class="d-flex"> <span class="mt-1"> Tarifa {{ index +1 }} </span> 
                                <Button
                                    v-if="showBtnDelete"
                                    :size="15"
                                    color="#dc3545"
                                    colorText="#ffffff"
                                    tooltip="Eliminar Tarifa"
                                    icon="fa fa-trash-alt"
                                    round
                                    :width="30"
                                    @click.native="deleteTariff(index)"
                                    class="ml-3"
                                    translate
                                />  
                            </h6>
                            <table class="table table-bordered text-center table-hover">
                                <thead >
                                    <tr class="table-active">
                                        <th scope="col">Naviera</th>
                                        <th scope="col">Naviera Salida</th>
                                        <th scope="col">POL</th>
                                        <th scope="col">POD</th>
                                        <th scope="col">Desde</th>
                                        <th scope="col">Hasta</th>

                                        <th scope="col">Unidad</th>
                                        <th scope="col">Commodity</th>
                                        <th scope="col">Atmósfera</th>

                                        <th scope="col">TT</th>
                                        <th scope="col">Comentario</th>

                                        <th scope="col">Neta (Costo)</th>
                                        <th scope="col">Pública (Venta)</th>
                                        <th scope="col"> Descuento </th>
                                        <th scope="col"> Acciones </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    <tr>
                                        <td> {{ item.naviera_id.name }} </td>
                                        <td> {{ item.naviera_salida_id.name }} </td>
                                        <td> {{ item.pol.name }} </td>
                                        <td> {{ item.pod.name }} </td>
                                        <td> {{ item.from_date }} </td>
                                        <td> {{ item.to_date }} </td>

                                        <td> {{ item.container_id.name }} </td>
                                        <td> {{ item.products_category_id.name }} </td>
                                        <td> {{ item.atmosphere_id.name }} </td>

                                        <td> {{ item.transit_time }} </td>
                                        <td> {{ item.comment }} </td>

                                        <td> {{ item.neta }} </td>
                                        <td> {{ item.public_value }} </td>
                                        <td> {{ item.discount }} </td>
                                        <td> </td>

                                    </tr>

                        
                                    <tr class="table-success" v-if="item.tariff_recharges.length > 0" >
                                        <th >Naviera</th>
                                        <th>Naviera Salida</th>
                                        <th>POL</th>
                                        <th>POD</th>
                                        <th>Desde</th>
                                        <th>Hasta</th>

                                        <th>Unidad</th>
                                        <th>Commodity</th>
                                        <th>Atmósfera</th>

                                        <th> Moneda </th>
                                        <th> Código Naviera </th>
                                        <th> Código Interno </th>
                                        <th> Pública </th>
                                        <th> Descuento </th>
                                        <th> Acciones </th>
                                    </tr>

                                    <tr :class="recharge.tariff_recharges_type.id ? 'table-success' : 'table-danger' " v-for="( recharge, ri) in item.tariff_recharges" :key="ri" >
                                        <td> {{ recharge.naviera_id.name }} </td>
                                        <td> {{ recharge.naviera_id_departure.name }} </td>
                                        <td> {{ recharge.pol.name }} </td>
                                        <td> {{ recharge.pod.name }} </td>
                                        <td> {{ recharge.from }} </td>
                                        <td> {{ recharge.to }} </td>

                                        <td> {{ recharge.container_id.name }} </td>
                                        <td> {{ recharge.products_category_id.name }} </td>
                                        <td> {{ recharge.atmosphere_id.name }} </td>

                                        <td> {{ recharge.currency_id.name  }} </td>
                                        <td> {{ recharge.tariff_recharges_type.name_external  }} </td>
                                        <td> {{ recharge.tariff_recharges_type.name_internal  }} </td>
                                        <td> {{ recharge.public_value }} </td>
                                        <td> - </td>
                                        <th>  
                                            <Button
                                                v-if="showBtnDelete"
                                                :size="13"
                                                color="#dc3545"
                                                colorText="#ffffff"
                                                tooltip="Eliminar Recargo"
                                                icon="fa fa-trash-alt"
                                                round
                                                :width="25"
                                                class="ml-4"
                                                @click.native="deleteRecharge( index, ri )"
                                                translate
                                            />   
                                        </th>
                                    </tr>
                                </tbody>
                            </table> 

                            <hr />
                        </div>
                    </div>

                </div>
            </div>
            <div class="row w-100" v-if="data.length > 0">
                <div class="col d-flex justify-content-end">
                    <Button
                        v-if="showBtnSave"
                        class="mt-3"
                        text="Guardar"
                        color="#21831b"
                        colorText="#fff"
                        :width="150"
                        :height="40"
                        icon="far fa-paper-plane"
                        title="Guardar"
                        horizontal
                        :inactive="btnStatus"
                        @click.native="!btnStatus && send()"
                    />

                    <Button
                        v-if="showBtnUpdate"
                        class="mt-3"
                        text="Actualizar"
                        color="#21831b"
                        colorText="#fff"
                        :width="150"
                        :height="40"
                        icon="far fa-paper-plane"
                        title="Actualizar"
                        horizontal
                        :inactive="btnStatus"
                        @click.native="!btnStatus && update()"
                    />

                </div>
            </div>
        </div>
        
        <ui-modal
            :title="`Agregar Valores a Diccionario`"
            size="normal" 
            ref="modal" 
            dismiss-on="close-button esc"
            @close="actionsSetShowModalAddValueDictionary(false)"
        >
            <div class="container">
                <div class="row">
                    <div class="col">
                        <h4 class="my-2"> Agregar Valor
                            <span v-if="typeValueDictionary == 1"> Puerto </span>
                            <span v-if="typeValueDictionary == 2"> Container </span>
                            <span v-if="typeValueDictionary == 3"> Commodity </span>
                        </h4>
                    </div>
                </div>

                <div class="row mt-3 w-100" >
                    <div class="col-6">

                        <ui-select
                            v-if="typeValueDictionary == 1"
                            label="Puertos"
                            class="w-100"
                            :keys="{ value: 'id', label: 'name' }"
                            placeholder="Seleccione"
                            :options="ports"
                            searchPlaceholder="Buscar"
                            has-search
                            v-model="valuesDictionaryPortInternal"
                        />
                        
                        <ui-select
                            v-if="typeValueDictionary == 2"
                            label="Containers"
                            class="w-100"
                            :keys="{ value: 'id', label: 'name' }"
                            placeholder="Seleccione"
                            :options="containers"
                            searchPlaceholder="Buscar"
                            has-search
                            v-model="valuesDictionaryPortInternal"
                        />

                        <ui-select
                            v-if="typeValueDictionary == 3"
                            label="Commodity"
                            class="w-100"
                            :keys="{ value: 'id', label: 'name' }"
                            placeholder="Seleccione"
                            :options="commodities"
                            searchPlaceholder="Buscar"
                            has-search
                            v-model="valuesDictionaryPortInternal"
                        />
                        
                    </div>
                    <div class="col-6">
                        <ui-textbox
                            class="w-100"
                            searchPlaceholder="Buscar"
                            label="Agregar Código Externo"
                            placeholder=""
                            v-model="valuesDictionaryPortExternal"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <Button
                            class="mt-3 float-right"
                            text="Agregar"
                            color="#21831b"
                            colorText="#fff"
                            :width="150"
                            :height="40"
                            icon="far fa-paper-plane"
                            title="Agregar"
                            horizontal
                            :inactive="btnStatusDictionary"
                            @click.native="!btnStatusDictionary && addValueToDictionary()"
                        />
                    </div>
                </div>
            </div>
            
        </ui-modal>
    </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';

import { addImporterQuotation, generateQuotationAddDictionaryValue, generateQuotationInit, getContratosPorNavieraYTipo, getQuotation, getQuotationNavieras, importQuotation, updateQuotation } from '../../../constants/lineas';
import Button from '../Button.vue';
import Loading from '../loading.vue';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

export default {
    data() {
        return {
            quotation : {},
            showDeleteBtn : true,
            btnStatus : false,
            btnStatusDictionary : false,
            data : [],
            quotationNavierasBaseList: [],
            quotationNavierasList: [],
            typeContract     : {},
            typeContractList : [],
            contractList : [],
            contract : {} ,
            quotationNumber : "",
            to   : "",
            from : "",
            description : "",

            loading : false,
            showImportFile : true ,
            showBtnUpdate  : false ,
            showBtnSave    : true ,
            showBtnDelete  : true ,

            typeValueDictionary : 0,
            quantityValuesDictionary : null,
            errors : [],
            valuesDictionaryPortInternal : {},
            valuesDictionaryPortExternal : "",
            labelValueInternal : {} ,
            valuesDictionaryContainer : {},
            containers : [],
            navieras : [],
            commodities : [],
            ports : [],
        };
    },
    props: {
        fncAfterSave : { type : Function , default: () => {} },
        idQuotation : { type : Number , default: null },
    },

    components: {
        Button,
        Loading,
        DatePicker
    },

 
    created() {
        this.init();
        this.getQuationNavierasData();
    },

    mounted() {},

    methods: {

        ...mapActions(["ActionSetZindexModal"]),
        
        ...mapActions("lineas", [
            'actionsSetShowModalAddValueDictionary'
        ]),

        openModal(ref){
            this.ActionSetZindexModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref){
            this.ActionSetZindexModal(false);
            this.$refs[ref].close();
        },

        clearInput(){
            document.getElementById('fileToImport').value = '';
            this.data = [] ;
        },

        async getFile() {

            if( ! this.quotation.id ){
                this.clearInput() ;
                return this.$vToastify.warning( "Para cargar excel, debe seleccionar el campo 'Cotización'" , "Error") ;
            } 

            if( ! this.contract.id ){
                this.clearInput() ;
                return this.$vToastify.warning( "Para cargar excel, debe seleccionar el campo 'Contrato'" , "Error") ;
            } 

            this.$vToastify.loader("Importando Información...");

            try {

                let form = new FormData ;

                form.append('file', document.getElementById('fileToImport').files[0] , 'quotation.xlsx' ) ;
                form.append('quotation_id', this.quotation.id ) ;
                form.append('contract_id' , this.contract.id ) ;

                const { status , data : { quotation_number , tariffs, to_date , from_date }  ,data} = await importQuotation( form );

                if( ! status ){
                    this.quantityValuesDictionary = data.data.length - 1 ;

                    this.errors = data.data ;
                    this.actionsSetShowModalAddValueDictionary(true) ;
                    this.$vToastify.stopLoader();
                    return this.$vToastify.warning( data.message , "Importante") ;
                }

                this.quotationNumber = quotation_number ;
                this.to              = to_date ;
                this.from            = from_date ;
                this.data            = tariffs ;
                this.description     = "" ;

                this.validTariffRechargesTypesAdded();
                
                return this.$vToastify.stopLoader();

            } catch (error) {

                this.clearInput() ;
                this.$vToastify.stopLoader();
                return this.$vToastify.error( "Hubo un problema al importar cotización. Favor, recargue la página y vuelva a intentar." , "Error") ;
            };

        },
        async getQuationNavierasData() {

            const { data } = await getQuotationNavieras();

            this.quotationNavierasList = data.map( d => ({ id : +d.id , name : d.name }) ) ;
            this.quotationNavierasBaseList = data ;

            data.length === 1 && (this.quotation = {
                id   : +data[0].id,
                name : data[0].name
            }) ;
        },
        async init(){

            const { data : { containers, navieras, commodities, ports } } = await generateQuotationInit() ;

            this.containers  = containers ;
            this.navieras    = navieras ;
            this.commodities = commodities ;
            this.ports       = ports ;
        },

        async getContracts(){

            if( ! this.quotation.id || ! this.typeContract.id ) return ;
       
            this.$vToastify.loader("Buscando Contratos...");

            try {

                const quotation = this.quotationNavierasBaseList.reduce( q => q.id == this.quotation.id );
         
                const form = {
                    naviera_id : + quotation.naviera_id,
                    type       : + this.typeContract.id
                };

                this.contractList = await getContratosPorNavieraYTipo( form ) ;
                
                this.$vToastify.stopLoader();

            } catch (error) {
                this.contractList = [];
                this.$vToastify.stopLoader();
            }
        },
        async send(){

            this.btnStatus = true ;

            const payload = {
                to   : this.to ,
                from : this.from ,
                quotation_number : this.quotationNumber ,
                id_tariff_importer_quotation_navieras : this.quotation.id ,
                id_contract  : + this.contract.id ,
                tariff_lines : this.data,
                description : this.description ?? null
            } ;

            this.$vToastify.loader("Guardando Cotización...");

            try {
                
                const { status , message } = await addImporterQuotation( payload );

                if( ! status ) {
                    this.$vToastify.stopLoader();
                    this.btnStatus = false ;
                    return this.$vToastify.warning( message, 'Precaución');
                } 

                this.$vToastify.stopLoader();

                this.btnStatus = false ;

                this.clearInput();

                this.contract = {};
                this.typeContract = {};

                this.fncAfterSave();
                
                return this.$vToastify.success("Se ha guardado cotización correctamente.", 'Éxito');

            } catch (error) {
                this.$vToastify.stopLoader();

                return this.$vToastify.error( "Error al guardar cotización. Favor, recargar página y volver a intentar." , "Error") ;
            }
        },

        async update(){

            this.btnStatus = true ;

            const payload = {
                id   : +this.idQuotation ,
                to   : this.to ,
                from : this.from ,
                description : this.description ? this.description : null ,
                quotation_number : this.quotationNumber ,
                id_tariff_importer_quotation_navieras : this.quotation.id ,
                id_contract  : + this.contract.id ,
                tariff_lines : this.data
            } ;

            this.$vToastify.loader("Actualizando Cotización...");

            try {
                
                const { status , message } = await updateQuotation( payload );

                if( ! status ) {
                    this.$vToastify.stopLoader();
                    this.btnStatus = false ;
                    return this.$vToastify.warning( message, 'Precaución');
                } 

                this.$vToastify.stopLoader();

                this.btnStatus = false ;

                this.fncAfterSave();
                
                return this.$vToastify.success("Se ha actualizado cotización correctamente.", 'Éxito');

            } catch (error) {

                this.$vToastify.stopLoader();
                return this.$vToastify.error( "Error al guardar cotización. Favor, recargar página y volver a intentar." , "Error") ;
            }
        },
        deleteTariff( index ) {
            this.data = this.data.filter( (d,i) => i != index );
        },
        deleteRecharge( indexTariff , indexRecharge ) {
            this.data[indexTariff].tariff_recharges = this.data[indexTariff].tariff_recharges.filter( (r,i) => i != indexRecharge );
        },
        async setData( idQuotation ){

            this.showBtnUpdate = true ;
            this.showBtnSave  = false ;

            this.loading = true ;
            const { data } = await getQuotation( idQuotation );

            this.typeContract = {
                id   : data.contract_type,
                name : data.contract_type_name
            };

            this.contract = {
                id   : data.id_contract,
                name : data.contract_name
            };

            this.showImportFile = false ;


            this.to = data.to ;
            this.from = data.from ;
            this.quotationNumber = data.quotation_number ;

            await this.getContracts() ;

            this.data = data.data ;
            this.description = data.description ;

            this.loading = false ;
        },

        updateDates() {
            
            this.data = this.data.map( d => ({
                ...d , 
                from_date : this.from,
                to_date   : this.to ,

                tariff_recharges : d.tariff_recharges.map( r => ({ 
                    ...r ,
                    from : this.from,
                    to   : this.to ,
                }))
            }));
        },
        async addValueToDictionary(){

            if( ! this.valuesDictionaryPortInternal.id ){
                
                let fieldName = "" ;
                if( this.typeValueDictionary == 1 ) fieldName = "Puertos" ;
                if( this.typeValueDictionary == 2 ) fieldName = "Containers" ;
                if( this.typeValueDictionary == 3 ) fieldName = "Commodity" ;
                
                return this.$vToastify.warning( `Campo '${ fieldName }' requerido`, 'Precaución'); 
            }

            if( !this.valuesDictionaryPortExternal ){
                return this.$vToastify.warning( "Campo 'Agregar Código Externo' requerido", 'Precaución'); 
            }

            const form = {
                id_tariff_importer_quotation_naviera : this.quotation.id ?? null ,
                id_type_tariff_importer_quotation_naviera : this.typeValueDictionary ,
                key_internal : this.valuesDictionaryPortInternal.id ?? null ,
                key_external : this.valuesDictionaryPortExternal ,
            } ;


            try {
            
                this.btnStatusDictionary = true ;

                this.$vToastify.loader("Agregando Valor...");

                await generateQuotationAddDictionaryValue( form ) ;

                let messageResponse = "Se ha guardado valor en diccionario. Favor, agregar siguiente valor." ;

                if( this.quantityValuesDictionary == 0 ){
                    messageResponse = "Se han guardado valores en diccionario."
                }

                this.$vToastify.stopLoader();
                this.$vToastify.success( messageResponse, "Éxito") ;

                this.btnStatusDictionary = false ;
                
                if( this.quantityValuesDictionary < 1 ){

                    this.quantityValuesDictionary = null ;
                    this.actionsSetShowModalAddValueDictionary( false ) ;
                    return this.getFile() ;
                }

                this.quantityValuesDictionary = this.quantityValuesDictionary - 1 ;
                
                
            } catch (error) {

                this.btnStatusDictionary = false ;
                this.$vToastify.stopLoader();

                return this.$vToastify.error( "Error al guardar información", "Error") ;
            };
        },

        async validTariffRechargesTypesAdded(){
            
            this.showBtnSave = true ;

            this.data.forEach( d => {

                d.tariff_recharges.forEach( r => {

                    if( ! r.tariff_recharges_type.id ) this.showBtnSave = false ;

                }) ;
            });

            !this.showBtnSave && this.$vToastify.error( "Hay códigos de naviera no asociados a nuestro sistema. Favor, agregar códigos marcados.", "Error Falta de Códigos") ;
        }
    },

    computed: {
        ...mapState(["tipoContratos" ]),

        ...mapState("lineas", ['showModalAddValueDictionary'])
    },

    watch: {

        idQuotation :  function( _new ){
            if( _new ) this.setData( _new ) 
        },

        from : function ( _new ) {
            if( _new ) this.updateDates( ) 
        },
        to : function ( _new ) {
            if( _new ) this.updateDates( ) 
        },
        showModalAddValueDictionary : function ( _new ) {
            _new ? this.openModal('modal') : this.closeModal('modal');
        },
        quantityValuesDictionary : function ( _new ) {

            if( _new !== null ) {

                this.valuesDictionaryPortInternal = {} ;
                this.valuesDictionaryPortExternal = this.errors[ _new ].value ; 
                this.typeValueDictionary          = this.errors[ _new ].type ;

                if( this.typeValueDictionary == 1 ) this.labelValueInternal = "Puerto"     ;
                if( this.typeValueDictionary == 2 ) this.labelValueInternal = "Containers" ;
                if( this.typeValueDictionary == 3 ) this.labelValueInternal = "Commodity"  ;
            }
        },
    },

    directives: {},

    filters: {}
};
</script>

<style>

:root {
    --import-recharges-gray-color : #575a57 ;
    --import-recharges-red-color : #dc143c ;
    --import-recharges-blue-color : rgba(12, 103, 201, .631372549) ;
    --import-recharges-green-color : #2da44e ;
    --import-recharges-white-color : #fff ;
}

#idImportadorCotizacionesFormComponent .info {
    width: 20px  ;
    height: 20px ;
    position: relative;
    border-radius: 3px;
}

#idImportadorCotizacionesFormComponent .delete {
    position: absolute;
    left: 95%;
    font-size: 1.2rem;
    color: var(--import-recharges-red-color);
    cursor: pointer;
    transition: transform .3s ease-out;
}

#idImportadorCotizacionesFormComponent .red {
    background-color: var(--import-recharges-red-color);
}

#idImportadorCotizacionesFormComponent .blue {
    background-color: var( --import-recharges-blue-color);
    color: var(--import-recharges-white-color);
}

#idImportadorCotizacionesFormComponent .green {
    background-color: var( --import-recharges-green-color);
    color: var(--import-recharges-white-color);
}

#idImportadorCotizacionesFormComponent .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 90% !important;
}

#idImportadorCotizacionesFormComponent .import {
    width: inherit;
    cursor: pointer;
}

#idImportadorCotizacionesFormComponent .mart-1 {
    margin-top: 1px;
}

#idImportadorCotizacionesFormComponent .b-order{
    border: 1.5px var( --import-recharges-gray-color ) dashed;
}

#idImportadorCotizacionesFormComponent .import::before {
    color: var(--import-recharges-white-color) ;
    content: "Seleccione archivo";
    display: inline-block;
    background: var( --import-recharges-gray-color );
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    cursor: pointer;
}

#idImportadorCotizacionesFormComponent input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

#idImportadorCotizacionesFormComponent .message-wait {
    min-height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var( --import-recharges-gray-color );
}

#idImportadorCotizacionesFormComponent .scroll {
  height: 600px ;
  overflow-y: scroll ;
}

#idImportadorCotizacionesFormComponent .mx-input {
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
    border-radius : 0px;
    margin-top: 21px;
}

#idImportadorCotizacionesFormComponent .label-date {
    color: rgba(0, 0, 0, 0.54);
    cursor: default;
    font-size: 0.9375rem;
    line-height: normal;
    margin-bottom: 0;
    transform-origin: left;
    transition: color 0.1s ease, transform 0.2s ease;
}

#idImportadorCotizacionesFormComponent input[type=file] {
    display: inline;
}
</style>

